const handleTableClone = () => {
    const $table = $('.table');
    const $clonedTable = $table.clone();
    const $container = $('.js-product');
    $clonedTable.addClass('js-cloned-table cloned-table');

    $container.append($clonedTable);
};

handleTableClone();
